import { useEffect, useState } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";

export default function ParticleBackground() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      initParticlesEngine(async (engine) => {
        await loadSlim(engine);
      }).then(() => setReady(true));
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  if (!ready) return null;

  return (
    <Particles
      id="tsparticles"
      options={{
        fullScreen: { enable: true, zIndex: 1 },
        fpsLimit: 60,
        particles: {
          number: {
            value: 200,
            density: { enable: true, area: 900 },
          },
          color: { value: ["#FFFFFF", "#6B7FD7", "#00E5FF", "#7B5EA7", "#F5A623"] },
          shape: { type: "circle" },
          opacity: {
            value: { min: 0.1, max: 0.9 },
            animation: {
              enable: true,
              speed: 1,
              minimumValue: 0.05,
              sync: false,
            },
          },
          size: {
            value: { min: 0.3, max: 3.5 },
            animation: {
              enable: true,
              speed: 1.5,
              minimumValue: 0.2,
              sync: false,
            },
          },
          move: {
            enable: true,
            speed: 0.5,
            direction: "none",
            random: true,
            straight: false,
            outModes: { default: "out" },
            attract: { enable: true, rotateX: 600, rotateY: 1200 },
          },
          links: {
            enable: false,
          },
        },
        interactivity: {
          events: {
            onHover: { enable: true, mode: "grab" },
          },
          modes: {
            grab: {
              distance: 160,
              links: {
                opacity: 0.15,
                color: "#00E5FF",
              },
            },
          },
        },
        detectRetina: true,
      }}
    />
  );
}
